/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { version_games } from './version_games';
export type contest = {
  id: string;
  name: string;
  updated_at: number;
  start_date: number;
  end_date: number | null;
  version_id: number;
  game: version_games;
  location: contest.location;
  address: string | null;
  latitude: number | null;
  longitude: number | null;
  source: string | null;
  participation: contest.participation;
  user_max: number;
  team_max: number;
  army_list_max: number;
  army_list_limit_date: number | null;
  show_all_armies: boolean;
  pool_size: number;
};
export namespace contest {
  export enum location {
    ON_LINE = 'OnLine',
    PHYSIQUE = 'Physique',
  }
  export enum participation {
    INDIVIDUAL = 'individual',
    TEAM = 'team',
  }
}
